/**
*
*   Content Block
*       - A left/right content block + image or video
*
**/
'use client';

import Config from '@/config';
import Image from '@/components/image';
import Button from '@/components/button';
import AllIngredients from '@/components/product/all-ingredients';
//import { gsap } from 'gsap';
//import { useGSAP } from "@gsap/react";
//import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useRef } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { Swiper, SwiperSlide } from 'swiper/react';
//import 'swiper/css';

//Load Module
//gsap.registerPlugin(useGSAP);
//gsap.registerPlugin(ScrollTrigger);

//Build the Element
export default function PrimaryNotes({ product, ...props }){

	const t             = useTranslations();
	const ref           = useRef();
	const locale        = useLocale();
	const swiper        = useRef();
	const PrimaryNotes  = {

			//The Swiper Settings
			Swiper: {

				//Params
				loop: true,
				centeredSlides: true,
				spaceBetween:   10,
				slidesPerView:  1,

				/**
				*
				*   next
				*       - Overrides default swiper to activate each slide
				*
				*   Params:
				*       n/a
				*
				**/
				onSwiper: instance => {

					//Go to Next
					swiper.current = instance;

				}

			},

			/**
			*
			*   next
			*       - Overrides default swiper to activate each slide
			*
			*   Params:
			*       n/a
			*
			**/
			next: e => {

				//Go to Next
				swiper.current.slideNext();

			},

			/**
			*
			*   previous
			*       - Overrides default swiper to activate each slide
			*
			*   Params:
			*       n/a
			*
			**/
			previous: e => {

				//Go to previous slide
				swiper.current.slidePrev();

			}
		};


/*
	//On Mount
	useGSAP(() => {

		//Skip if it hasn't loaded
		if( !ref.current ) return;

		//Prepare the MatchMedia
		let mm = gsap.matchMedia();

		//Set Variables
		const $section      = ref.current.querySelector('[data-viewport="mobile"]');
		const $image        = $section.querySelectorAll('img');
		const $title        = $section.querySelectorAll('h2 *');
		const $subtext      = $section.querySelector('h2 + p');
		const $ingredient   = $section.querySelectorAll('h3');
		const $description  = $section.querySelectorAll('.list p, .list .details > span');
		const $nav          = $section.querySelector('nav');
		const $button       = $section.querySelector('footer');

		//
		mm.add('(max-width: 750px)', context => {

			//Create Timeline
			let timeline = gsap.timeline({
				scrollTrigger: {
					trigger:                $section,
					invalidateOnRefresh:    true,
					scrub:                  true,
					pin:                    false,
					markers:                false,
					once:                   true,
					start:                  '-100% left',
					end:                    '0 left',
				},
			});

			//Each title part
			$title.forEach(
				( $part , i ) => timeline.delay( ( i * 1 ) ).fromTo( $part, { opacity:0, yPercent:10 },{ opacity:1, yPercent:0 })
			);

			//The Description
			timeline.fromTo( $subtext , { opacity:0, yPercent:10 }, { opacity:1, yPercent:0 });

			//Description & Button Last
			timeline.fromTo( $image, { opacity:0, scale:0, yPercent:10 },{ opacity:1, scale:1, yPercent:0 });

			//Description & Button Last
			timeline.fromTo( [ $ingredient , $description , $button , $nav ], { opacity:0, yPercent:10 },{ opacity:1, yPercent:0 });

		});

	}, { scope: ref.current });
*/
	//Return
	return (
		<section id="primary-notes" ref={ ref }>
			<div data-viewport="desktop">
				<header>
					<h2>{ t.rich('Pages.Product.primary-notes.title', Config.i18n.html) }</h2>
				</header>
				<ul className="list">{
					product.primaryNotes.map( ( ingredient , i ) => (
						<li key={ i }>
							<Image src={ ingredient.image?.[0]?.src } alt="" width="110" height="110" />
							<h3>{ ingredient.name[ locale ] }</h3>
							<div className="details">
								<span className="inci">{ ingredient.inci }</span>
								<span className="origin">from { ingredient.origin[ locale ] }</span>
								<span className="extraction">{ ingredient.extraction[ locale ] }</span>
							</div>
							<p>{ ingredient.description[ locale ] }</p>
						</li>
					))
				}</ul>
			</div>
			<div data-viewport="mobile">
				<header>
					<h2 dangerouslySetInnerHTML={{
						__html: product.blocks.ingredients.title?.[ locale ]
					}} />
					<p>{ product.blocks.ingredients.description?.[ locale ] }</p>
				</header>
				<div className="swiper-parent">
					<Swiper {...PrimaryNotes.Swiper} className="list">{
						product.primaryNotes.map( ( ingredient , i ) => (
							<SwiperSlide key={ i }>
								<Image src={ ingredient.image?.[0]?.src } alt="" width="110" height="110" />
								<h3>{ ingredient.name[ locale ] }</h3>
								<div className="details">
									<span className="inci">{ ingredient.inci }</span>
									<span className="origin">from { ingredient.origin[ locale ] }</span>
									<span className="extraction">{ ingredient.extraction[ locale ] }</span>
								</div>
								<p>{ ingredient.description[ locale ] }</p>
							</SwiperSlide>
						))
					}</Swiper>
					<nav>
						<Button onClick={ () => PrimaryNotes.previous() }>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
								<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Button>
						<Button onClick={ () => PrimaryNotes.next() }>
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
								<path d="M10.6317 1.81006L18.4803 9.65863L10.6317 17.5072" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M18.4802 9.65869L1.78296 9.65869" stroke="white" strokeWidth="1.85526" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</Button>
					</nav>
				</div>
				<footer>
					<AllIngredients product={ product } />
				</footer>
			</div>
		</section>
	);

}